// extracted by mini-css-extract-plugin
export default {"switch":"omnia_switch__switch--RvML","flipped":"omnia_switch__flipped--OXPa","text":"omnia_switch__text--FSnM"};